// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nj-1";
export var stateContainer = "_nj-0";